<template>
  <div class="parent-box">
    <!-- step 1 -->
    <div class="container">
      <h2 class="page-header">KYC Documents</h2>
      <div>
      </div>

      <div class="row">
      <div class="col-md-3 card">
      <h3>KYYC DOCUMENTS TYPES</h3>
      <p>Means of Identification</p>
      <ul>
      <a href="#"><li class="text-primary">International Passports</li></a>
      <br />
            <A href="#"><li class="text-primary">Driving License</li></a>
            <br />
     

      </ul>
      <br />
      <br />
      <p>Utility Bills</p>
      <ul>
      <a href="#"><li class="text-primary">Waste Bill</li></a>
      <br />
            <A href="#"><li class="text-primary">Nepa Bill</li></a>
            <br />
     

      </ul>


      </div>
      <div class="col-md-1">
      </div>
      <div class="col-md-8 card">
      <h3 class="page-header">KYC INFORMATIONS </h3>
      <div>
      <p>Image: </p>

      <br />
      <p>Expiry Date: </p>
      </div>
      </div>
      </div>
    </div>
    <div class="footer">
      <!-- real footer item -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";

export default {
  name: "FinishTab",
  props: {
    getUserSession: null
  },
  components: {},
  computed: {},
  data() {
    return {
      form: {
        bvn: ""
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    gotoNextState() {
      // this.$emit("updateStatus");
    }
  },
  async mounted() {}
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/customer-admin/Kyc.vue